import { formatHours } from "Utils/utils";

/** e.g. 1500 → "1,500" */
export const formatKpiCount = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString("en-AU");
};

/** e.g. 1500/2000 → "1,500/2,000" */
export const formatKpiRatio = (numerator, denominator) =>
  `${formatKpiCount(numerator)}/${formatKpiCount(denominator)}`;

/**
 * Hours for KPI cards — compact when large (6000:00 → "6,000h").
 * Backend sends HH:MM:SS from billable seconds.
 */
export const formatKpiHoursPart = (time) => {
  if (!time) return "0h";

  const parts = String(time).split(":");
  const hours = parseInt(parts[0], 10) || 0;
  const minutes = parseInt(parts[1], 10) || 0;

  if (hours >= 100) {
    const hoursLabel = hours.toLocaleString("en-AU");
    return minutes > 0 ? `${hoursLabel}h ${minutes}m` : `${hoursLabel}h`;
  }

  return formatHours(time) || "0:00";
};

export const formatKpiHoursRatio = (approved, total) =>
  `${formatKpiHoursPart(approved)}/${formatKpiHoursPart(total)}`;
